function goToByScroll(id) {
    id = id.replace("link", "");
    $('html,body').animate({
        scrollTop: $("#" + id).offset().top - 70
    }, 'fast');
}

$(".page-testimonials-section .category-inner .category").click(function(){
  $(".page-testimonials-section .category-inner .category").removeClass("active");
  $(this).addClass("active");
  $(".page-testimonials-section .testimonials-list").hide();
  var cat = $(this).data("category");
  $("#"+cat+"__testimonials").show();
  if($(window).width() < 768){
    goToByScroll(cat+"__testimonials");
  }
});

$(function () {
    for(var i = 1; i <= 10; i++ ){
      $(".wall-of-love__wrapper .box-"+i).show();
    }
    var n = 10;
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        for(var i = n+1; i <= n+10; i++ ){
          $(".wall-of-love__wrapper .box-"+i).slideDown();
        }
        n = n + 10;
        if ($(".wall-of-love__wrapper.mobile-hide .box:hidden").length == 0) {
            $("#loadMore").fadeOut('slow');
        }
        if ($(".wall-of-love__wrapper.desktop-hide .box:hidden").length == 0) {
            $("#loadMore").fadeOut('slow');
        }
    });
});

$(function () {
  $(".piq-testimonials__slider").slick({
    infinite: true,
    arrows: false,
    dots: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  var maxHeight=Math.max.apply(null,$(".piq-testimonials__slider .testimonial-item").map(function(){
    return $(this).find(".testimonial-inner").height()
  }).get());
  $(".piq-testimonials__slider .testimonial-inner").css("min-height", maxHeight+"px");
});